/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Wrong_FolderInputs */

const en_issue_wrong_folder = /** @type {(inputs: Issue_Wrong_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this file was not uploaded as a product image`)
};

/**
* | output |
* | --- |
* | "this file was not uploaded as a product image" |
*
* @param {Issue_Wrong_FolderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_wrong_folder = /** @type {((inputs?: Issue_Wrong_FolderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Wrong_FolderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_wrong_folder(inputs)
});